import { render, staticRenderFns } from "./emissionTreatmentDoc.vue?vue&type=template&id=6c24bb99"
import script from "./emissionTreatmentDoc.vue?vue&type=script&lang=js"
export * from "./emissionTreatmentDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c24bb99')) {
      api.createRecord('6c24bb99', component.options)
    } else {
      api.reload('6c24bb99', component.options)
    }
    module.hot.accept("./emissionTreatmentDoc.vue?vue&type=template&id=6c24bb99", function () {
      api.rerender('6c24bb99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/toe/emissionTreatmentDoc.vue"
export default component.exports